/**
 * MusicPlayer
 * v1.1 增加音乐音量可保持
 */


import React, { useEffect, useState } from 'react'
import { Row, Col, Tooltip, Button } from 'antd'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { RHAP_UI } from 'react-h5-audio-player';
import { IconAbout, IconCopy } from '@/components/Icon';
import { bytesToHumanReadableSize } from '@/plugin/tools/tools';
//
/**
 * 
 * https://github.com/lhz516/react-h5-audio-player
 * https://www.npmjs.com/package/react-h5-audio-player
 */
export default function MusicPlayer(props) {
    // console.log(2300, '播放器最终接收到的信息', props);
    const {src, size} = props
    // 存储音量到本地
    // # 判断本地是否有值，有值就取，没有就设置为1
    const _musicVolume = localStorage.getItem('musicVolume') === 'NaN' ? 1 : parseFloat(localStorage.getItem('musicVolume'))
    const [musicVolume, setMusicVolume] = useState(_musicVolume)
    useEffect(() => {
        localStorage.setItem('musicVolume', musicVolume.toFixed(1))
    }, [musicVolume])

    const copyLink = () => { navigator.clipboard.writeText(src) }
    const copyCID = () => { navigator.clipboard.writeText(src.match(/\/ipfs\/([A-Za-z0-9]+)/)[1]) }

    return (
        <Row>
            <Col span={24}
                style={{
                    // position: "absolute", bottom: 0,
                    // border:'solid',
                    width: "100%"
                }}
            >
                <AudioPlayer
                    autoPlay={true}
                    showSkipControls={true}
                    showDownloadProgress={true}
                    header='当前无播放'
                    onVolumeChange={(event) => { setMusicVolume(event.target.volume) }}
                    volume={musicVolume}
                    customProgressBarSection={  // 进度条区域
                        [
                            RHAP_UI.DURATION, // 时长
                            RHAP_UI.PROGRESS_BAR, //进度条
                            RHAP_UI.CURRENT_TIME, // 当前播放进度
                            // <div>/</div>,

                        ]
                    }
                    customControlsSection={  // 播放按钮区域
                        [
                            // <div>This is an  </div>,
                            RHAP_UI.ADDITIONAL_CONTROLS,
                            RHAP_UI.MAIN_CONTROLS,
                            RHAP_UI.VOLUME_CONTROLS,
                            RHAP_UI.VOLUME,   // 音量控制组件

                        ]
                    }
                    customAdditionalControls={ // 播放按钮区域，左侧
                        [
                            RHAP_UI.LOOP,
                            <Tooltip
                                // color={'white'}

                                placement={'bottom'}
                                title={
                                    <>
                                        <Row>
                                            <Col>
                                                <span>{bytesToHumanReadableSize(size? size : void 0)}</span>
                                            </Col>
                                            <Col>
                                                <Tooltip title={src ? src : void 0}>
                                                    <Button icon={<IconCopy />} onClick={() => { copyLink() }}>复制链接</Button>
                                                </Tooltip>
                                                <Tooltip title={src ? src.match(/\/ipfs\/([A-Za-z0-9]+)/)[1] : void 0}>
                                                    <Button icon={<IconCopy />} onClick={() => { copyCID() }}>复制CID</Button>
                                                </Tooltip>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            >
                                <Button icon={<IconAbout fontSize={22} />} />
                            </Tooltip>
                        ]
                    }
                    customVolumeControls={[]} // 播放按钮区域右侧
                    // customIcons={{  // 自定义图标
                    //     play: < />  // 播放图标
                    // }}
                    // layout="stacked-reverse"  //  'stacked' | 'horizontal' | 'stacked-reverse' | 'horizontal-reverse' | 'stacked' 
                    {...props}
                />
            </Col>
        </Row>
    )
}